import { PlatformMembershipWithTeam } from '@cloudquery/api-platform';
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus, setCustomHandlerMembership } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformCreateTeamMockHandler = () => {
  return http.post('*/teams', async (info) => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const body: any = await info.request.json();

    const team: PlatformMembershipWithTeam = {
      roles: ['admin:write'],
      team: {
        created_at: `${new Date().toISOString().split('.')[0]}Z`,
        display_name: body.display_name,
        internal: true,
        is_trial_active: false,
        name: body.name,
        plan: 'paid',
        plan_end_time: `${faker.date.future().toISOString().split('.')[0]}Z`,
        trial_end_time: `${faker.date.future().toISOString().split('.')[0]}Z`,
      },
    };

    setCustomHandlerMembership(team);

    return HttpResponse.json(team, { status: 201 });
  });
};
